export default __webpack_public_path__ + "static/media/5.c03c7d8b.png";